export default "__VITE_ASSET__CXQoHTLo__"